import { Tab, TabProps, Tabs, useMediaQuery } from '@mui/material';

import { useTranslation } from 'react-i18next';

import theme from 'styles/theme/theme';
import { SettingsTab } from 'types/AppTypes';

interface SettingsTabsProps {
  tabs: SettingsTab[];
  activeTab: string;
  setActiveTab: Function;
  /**
   * This should a tabs dictionary that returns the translation key for the tab
   */
  i18nDictionary: Record<string, () => string>;
}

export const SettingsTabs = ({
  tabs,
  i18nDictionary,
  activeTab,
  setActiveTab
}: SettingsTabsProps) => {
  const { t } = useTranslation();
  const biggerThanXS = useMediaQuery(theme('de').breakpoints.up('md'));

  const SettingsTab = (props: TabProps) => (
    <Tab
      {...props}
      style={{
        padding: '0em 1em',
        border: '0.5px solid #ddd',
        justifyContent: biggerThanXS ? 'flex-start' : 'center',
        minHeight: '3.5em',
        ...props.style
      }}
      iconPosition="start"
    />
  );

  return (
    <Tabs
      value={activeTab}
      onChange={(_, newVal) => setActiveTab(newVal)}
      orientation="vertical"
      aria-label="vertical tabs example"
    >
      {tabs.map((settings, index) => (
        <SettingsTab
          key={settings.value}
          value={settings.value}
          icon={settings.icon}
          label={biggerThanXS ? t(i18nDictionary[settings.value]()) : undefined}
          style={{
            ...settings.style,
            ...(index === 0 ? { borderTopLeftRadius: 12 } : {}), // style for first item
            ...(index === tabs.length - 1 ? { borderBottomLeftRadius: 12 } : {}) // style for last item
          }}
        />
      ))}
    </Tabs>
  );
};
